// Auth
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

// Users
export const USERS_FETCH = 'USERS_FETCH';
export const USER_ID_FETCH = 'USER_ID_FETCH';

// Equipes
export const EQUIPES_FETCH = 'EQUIPES_FETCH';

// Dialog
export const SET_DIALOG = 'SET_DIALOG';
export const SET_DIALOG_CONTENT_PROP = 'SET_DIALOG_CONTENT_PROP';
export const SET_DIALOG_PROP = 'SET_DIALOG_PROP';


// Loading
export const LOADING = 'LOADING';
